@use '~/theme/theme' as *;
@use '~/theme/typography';

.tabs {
  list-style-type: none;
  display: flex;
  width: fit-content;

  &.underlined {
    border-bottom: 2px solid color(grey-200);
  }

  &.boxed {
    border: 1px solid color(grey-400);
    border-radius: 8px;
  }

  .tab {
    padding: spacing(1.625) spacing(3);
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    gap: spacing(1);
    justify-content: center;
    align-items: center;
    position: relative;

    .tabLabel {
      @include typography.body2;
      @include typography.regular;
    }

    &[data-selected] {
      .tabLabel {
        @include typography.body2;
        @include typography.semibold;
      }
    }

    .icon {
      width: 20px;
      height: 20px;
    }

    .notificationBadge {
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background-color: color(lobster-800);
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &[data-focus-visible] {
      outline: 2px solid color(violet-600);
      outline-offset: -2px;
    }

    &.boxed {
      border-right: 1px solid color(grey-400);

      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-right: 0;
      }

      &[data-selected] {
        background-color: color(violet-600);
        color: white;

        &[data-focus-visible] {
          outline-color: white;
        }
      }

      &[data-disabled] {
        background-color: color(grey-200);
        color: color(grey-600);
      }

      &:hover {
        &:not([data-disabled]) {
          &:not([data-selected]) {
            background-color: color(violet-100);
          }
        }
      }
    }

    &.underlined {
      &[data-selected] {
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: black;
        }
      }

      &:hover {
        &:not([data-disabled]) {
          &:not([data-selected]) {
            &::after {
              content: '';
              position: absolute;
              bottom: -2px;
              left: 0;
              right: 0;
              height: 2px;
              background-color: black;
            }
          }
        }
      }
    }

    &.default {
      border-bottom: 2px solid transparent;

      &[data-selected] {
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: black;
        }
      }

      &:hover {
        &:not([data-disabled]) {
          &:not([data-selected]) {
            &::after {
              content: '';
              position: absolute;
              bottom: -2px;
              left: 0;
              right: 0;
              height: 2px;
              background-color: black;
            }
          }
        }
      }
    }
  }

  .tab[data-disabled] {
    cursor: default;
    color: color(grey-600);

    .notificationBadge {
      span {
        color: white;
      }
    }
  }
}
